import { InputControl } from "@ht/components";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { MessageBox } from "../../components/message-box";

const WidgetSampleMobile = () => {
    const { control, handleSubmit } = useForm();
    const [showMessageBox, setShowMessageBox] = useState(false);
    const validationMessage = "";
    const closeMessageBoxHandler = () => {
        setShowMessageBox((prev) => !prev);
    };
    const name = useWatch({ control, name: "name" });
    const email = useWatch({ control, name: "email" });
    const [submited, setSubmited] = useState(false);

    useEffect(() => {
        if (submited) {
            const script = document.createElement('script');

            script.src = String(process.env.REACT_APP_WIDGET_SAMPLE);
            script.setAttribute("service-group-id", String(process.env.REACT_APP_WIDGET_SAMPLE_SERVICE_GROUP));
            script.setAttribute("tenant-id", String(process.env.REACT_APP_WIDGET_SAMPLE_TENANT));
            script.setAttribute("tag", "generic");
            script.setAttribute("username", email);
            script.setAttribute("fullname", name);
            script.setAttribute("hide-icon", "");
            script.setAttribute("hide-close-btn", "");
            script.setAttribute("hide-back-btn", "");
            script.setAttribute("width", "100%");
            script.setAttribute("height", "100%");

            script.async = true;

            const container = document.getElementById("widget-sample");
            container?.appendChild(script);
            setSubmited(false);
            return () => {
                container?.removeChild(script);
            }
        }
    }, [submited]);
    const startChatHandler = (result: any) => {
        setSubmited(true);
    }
    return (
        <div className="flex flex-col static ">
            <MessageBox type="warning" visible={showMessageBox} closeHandler={closeMessageBoxHandler} title="Warning" message={validationMessage} />
            <form onSubmit={handleSubmit(startChatHandler)} >
                <div className="flex py-6 px-4 flex-col gap-6 items-center bg-white absolute right-[40%] top-0 rounded-md z-30 shadow-lg">
                    <div className="flex flex-col items-start gap-1.5 self-stretch">
                        <div className="text-gray-900 font-bold text-lg">Chat with us now</div>
                    </div>
                    <div className="flex flex-col items-start gap-2.5 self-stretch">
                        <div className="flex flex-col gap-0.5 justify-center items-start self-stretch">
                            <div className="text-base font-bold text-gray-900">Name</div>
                            <div className="flex py-2 px-3 items-center gap-2.5 self-stretch bg-gray-100 rounded-md">
                                <InputControl control={control} name="name" className="!p-0 !bg-gray-100" placeHolder="Enter name" />
                            </div>
                        </div>
                        <div className="flex flex-col gap-0.5 justify-center items-start self-stretch">
                            <div className="text-base font-bold text-gray-900">Email Address</div>
                            <div className="flex py-2 px-3 items-center gap-2.5 self-stretch bg-gray-100 rounded-md">
                                <InputControl control={control} name="email"
                                    placeHolder="Enter email address"
                                    className="!p-0 !bg-gray-100" />
                            </div>
                        </div>
                    </div>
                    <button type="submit"
                        className={clsx("flex py-2.5 px-4 items-center justify-center gap-2.5 rounded-lg self-stretch bg-primary text-white")}>
                        <span className="text-md font-bold">Start Chat</span>
                    </button>
                </div>
            </form>
            <div id="widget-sample"></div>
        </div>
    );
};

export default WidgetSampleMobile;
